import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  IPortalUserFilter,
  IPortalUserRoleEnum,
  IPortalUserSortColumnEnum,
} from 'Modules/Communication/PortalUsers/shared/models/PortalUsers'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'
import { ISortOrderEnum } from 'shared/models/List'

const portalUsersSlice = createSlice({
  name: 'portalUsers',
  initialState: {
    filters: {
      clientId: '',
      searchText: '',
      portalUserRole: IPortalUserRoleEnum.all,
      sortColumn: IPortalUserSortColumnEnum.name,
      sortorder: ISortOrderEnum.asc,
      take: DEFAULT_PAGE_TAKE,
      skip: 0,
    } as IPortalUserFilter,
  },
  reducers: {
    updateFilters: (state, action: PayloadAction<IPortalUserFilter>) => {
      state.filters = action.payload
    },
  },
})

export default portalUsersSlice
